export const Colors = {
  PRIMARY_HIGHLIGHT_COLOR: 0xBF2172ff,
  SECONDARY_HIGHLIGHT_COLOR: 0xE56BAAff,
  TERNARY_COLOR: 0xdcdcdcff,
  TERNARY_LINK: 0x88888844
};

export const LayerLevels = {
  Polygons: 0,
  Edges: 5,
  HighlightedEdges: 7,
  Nodes: 10,
  Labels: 12,
  Text: 15
}

export const NamedGroups = {
  MainGraph: 'main-graph-view'
}